import { render, staticRenderFns } from "./copy-btn.vue?vue&type=template&id=2b89ebd8&scoped=true"
import script from "./copy-btn.vue?vue&type=script&lang=js"
export * from "./copy-btn.vue?vue&type=script&lang=js"
import style0 from "./copy-btn.vue?vue&type=style&index=0&id=2b89ebd8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b89ebd8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b89ebd8')) {
      api.createRecord('2b89ebd8', component.options)
    } else {
      api.reload('2b89ebd8', component.options)
    }
    module.hot.accept("./copy-btn.vue?vue&type=template&id=2b89ebd8&scoped=true", function () {
      api.rerender('2b89ebd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/copy-btn.vue"
export default component.exports